// SPDX-License-Identifier: AGPL-3.0-or-later
const GUILD_ICON_INITIALS_MAX_LENGTH = 4;

export function truncateInitials(initials: string, maxLength: number): string {
	if (maxLength <= 0) return '';
	return Array.from(initials).slice(0, maxLength).join('');
}

export function getGuildIconDisplayInitials(initials: string): string {
	return truncateInitials(initials, GUILD_ICON_INITIALS_MAX_LENGTH);
}

export function getInitialsLength(initials: string): 'short' | 'medium' | 'long' {
	const length = Array.from(initials).length;
	if (length <= 2) return 'short';
	if (length <= 4) return 'medium';
	return 'long';
}
